import React from 'react';

const InformationText = props => (
        <label className={props.field.class} >{props.input.value}</label>
);

export default InformationText;
